export default {
  errorText: "Error, "
};